import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import am5geodata_usaLow from "@amcharts/amcharts5-geodata/usaLow";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import confetti from 'canvas-confetti';

const regionalInteractive = (gsap, lenis, Flip, $container) => {
	
	// Store cleanup functions
	const cleanupFunctions = [];
	
	am5.addLicense("AM5M-2767-5738-8708-8992");
	am5.addLicense("MP2767-5738-8708-8992");

	
	const $riContainer = $container.find('.regional-interactive-container');
	const $scrollableData = $container.find('.scrollable-data');
	const mq = window.matchMedia('(min-width: 61rem)');
	let canvas = $container.find('.confetti_canvas');
	canvas.confetti = canvas.confetti || confetti.create(canvas, { resize: true });
	
	/***************************************************************
		Scrollable Data
	***************************************************************/

	function updateLenisPrevent(e, $el) {
		if (e.matches) {
			//$el.attr('data-lenis-prevent', '');
		} else {
			//$el.removeAttr('data-lenis-prevent');
		}
	}
	
	// Track last window height to detect URL bar changes
	let lastWindowHeight = window.innerHeight;

	// Debounced resize handler
	const handleResize = debounce(() => {
		const currentHeight = window.innerHeight;
		// Only trigger if the height change is significant (not just URL bar)
		if (Math.abs(currentHeight - lastWindowHeight) > 150) {
			$scrollableData.each(function() {
				updateLenisPrevent(mq, $(this));
			});
			lastWindowHeight = currentHeight;
		}
	}, 800);

	$scrollableData.each(function() {
		const $this = $(this);
		
		if (mq.addEventListener) {
			mq.addEventListener('change', function(e) {
				updateLenisPrevent(e, $this);
			});
		} else {
			mq.addListener(function(e) {
				updateLenisPrevent(e, $this);
			});
		}

		// Initial run on page load
		updateLenisPrevent(mq, $this);

		// Also re-check on any window resize
		$(window).on('resize', handleResize);
	});
	
	// Helper function for debouncing
	function debounce(func, wait) {
		let timeout;
		return function(...args) {
			const context = this;
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(context, args), wait);
		};
	}
	
	// Custom scrollbar functionality
	function initCustomScrollbar($container) {
		if (!mq.matches) return;

		const $scrollable = $container.find('.scrollable-data');
		const $scrollbar = $('<div class="custom-scrollbar"><div class="scrollbar-thumb"></div></div>');
		
		$scrollable.after($scrollbar);
		const $thumb = $scrollbar.find('.scrollbar-thumb');
		
		function updateScrollbar() {
			const scrollHeight = $scrollable[0].scrollHeight;
			const clientHeight = $scrollable[0].clientHeight;
			const scrollTop = $scrollable[0].scrollTop;
			
			// Calculate thumb height and position
			const thumbHeight = ((clientHeight / scrollHeight) - 0.05) * clientHeight;
			const thumbTop = (scrollTop / scrollHeight) * clientHeight;
			
			$thumb.css({
				height: `${thumbHeight}px`,
				transform: `translateY(${thumbTop}px)`
			});
		}
		
		// Update scrollbar on scroll
		$scrollable.on('scroll', updateScrollbar);
		
		// Initial update
		updateScrollbar();
		
		// Update on resize
		$(window).on('resize', updateScrollbar);
		
		// Cleanup function
		return () => {
			$scrollable.off('scroll', updateScrollbar);
			$(window).off('resize', updateScrollbar);
			$scrollbar.remove();
		};
	}

	// Initialize custom scrollbar for each scrollable container
	$scrollableData.each(function() {
		const cleanup = initCustomScrollbar($(this).parent());
		if (cleanup) cleanupFunctions.push(cleanup);
	});
	
	/***************************************************************
		Round Navigation Function
	***************************************************************/
	
	const navigateToRound = (targetRoundId, clickedElement) => {
		const $rounds = $riContainer.find('.regional-interactive-round-wrapper');
		const $activeRound = $rounds.filter('.active');
		const $targetRound = $rounds.find(`.regional-interactive-round-wrapper[data-round-id="${targetRoundId}"]`);
		
		// Trigger confetti when reaching the final round (round 5)
		if (targetRoundId === 6) {
			confetti({
				particleCount: 150,
				spread: 360,
				decay: 0.94,
			});
		}
		
		// Close any open modals
		if ($riGameModals.hasClass('open')) {
			$riGameModals.removeClass('open');
			$riGameModals.find('.game-modal.open').removeClass('open');
			$riGameModalOpens.add($riContainer).removeClass('active');
			if (!mq.matches) {
				lenis.start();
			}
		}
		
		// Update mobile dropdown
		$riMobileDropdownMenu.removeClass('active disabled');
		const $targetMenuItem = $riMobileDropdownMenu.filter(`[data-round-id="${targetRoundId}"]`);
		$targetMenuItem.addClass('active');
		$riMobileDropdownMenu.filter(`[data-round-id="${$activeRound.data('round-id')}"]`).addClass('disabled');
		
		// Update mobile title text
		const selectedText = $targetMenuItem.text().trim();
		$riMobileDropdownToggle.find('.ri-mobile-title').text(selectedText);
		
		// Update pagination
		$riContainer.find('.round-pagination button').removeClass('active');
		$riContainer.find(`.round-pagination button[data-round-id="${targetRoundId}"]`).addClass('active');
		
		const $ball = $riContainer.find('.round-pagination .ball-follow');
		const targetButtons = gsap.utils.toArray('.round-pagination button');
		
		function moveIndicator(toIndex) {
			const state = Flip.getState($ball[0]);
			const spinDirection = clickedElement.classList.contains('round-next') ? 0.5 : -0.5;
			targetButtons[toIndex].appendChild($ball[0]);

			Flip.from(state, {
				duration: 0.6,
				spin: spinDirection,
				ease: "power2.inOut",
			});
		}
		
		moveIndicator(targetRoundId - 1);
		
		const handleRoundTransition = () => {
			// Fade out current round and fade in target round
			$rounds.fadeOut(400, function() {
				$(this).removeClass('active');
			}).end().find(`.regional-interactive-round-wrapper[data-round-id="${targetRoundId}"]`).fadeIn(400, function() {
				$(this).addClass('active');

				// Update previous/next buttons
				if (targetRoundId > 1) {
					$riContainer.find('.round-previous').removeClass('disabled');
				} else {
					$riContainer.find('.round-previous').addClass('disabled');
				}

				if (targetRoundId > 5) {
					$riContainer.find('.round-next').addClass('disabled');
				} else {
					$riContainer.find('.round-next').removeClass('disabled');
				}

				// Update scrollbars after transition
				$riContainer.find('.scrollable-data').each(function() {
					const $scrollable = $(this);
					const $scrollbar = $scrollable.next('.custom-scrollbar');
					if ($scrollbar.length) {
						const scrollHeight = $scrollable[0].scrollHeight;
						const clientHeight = $scrollable[0].clientHeight;
						const scrollTop = $scrollable[0].scrollTop;
						
						const thumbHeight = ((clientHeight / scrollHeight) - 0.05) * clientHeight;
						const thumbTop = (scrollTop / scrollHeight) * clientHeight;
						
						$scrollbar.find('.scrollbar-thumb').css({
							height: `${thumbHeight}px`,
							transform: `translateY(${thumbTop}px)`
						});
					}
				});
			});
		};

		// Check if screen width is 61rem or less (976px)
		if (window.innerWidth <= 976) {
			lenis.scrollTo($riContainer.get(0), {
				offset: -63,
				duration: 0.4,
				lerp: 0,
				onComplete: handleRoundTransition
			});
		} else {
			handleRoundTransition();
		}
	};

	// Add window resize handler
	let resizeTimeout;
	$(window).on('resize', function() {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function() {
			// Handle any resize-specific updates here
		}, 250);
	});
	
	/***************************************************************
		Mobile dropdown & Rounds navigation
	***************************************************************/
	
	const $riMobileDropdown = $riContainer.find('.ri-mobile-dropdown');
	const $riMobileDropdownToggle = $riContainer.find('.ri-mobile-dropdown-toggle');
	const $riMobileDropdownMenu = $riContainer.find('.ri-mobile-dropdown-menu li');
	
	// MOBILE DROPDOWN
	if ($riMobileDropdown.length) {
		
		$riMobileDropdownToggle.on('click', function(e) {
				e.preventDefault();
				const $dd     = $riMobileDropdown;
				const isOpen  = $dd.toggleClass('open').hasClass('open');
				$(this).attr('aria-expanded', isOpen);
		});
		
		$riMobileDropdownMenu.each(function() {
			const $this = $(this);
			$this.on('click', function() {
				const selectedText = $this.text().trim();
				const $dd   = $this.closest('.ri-mobile-dropdown');
				const $btn  = $dd.find('.ri-mobile-dropdown-toggle');
				const targetRoundId = $this.data('round-id');
				
				$btn.find('.ri-mobile-title').text(selectedText);
				$btn.attr('aria-expanded', 'false');
				$dd.removeClass('open');
				
				navigateToRound(targetRoundId, this);
			});
		});
	
	}
	
	// ROUNDS NAVIGATION
	const $riRoundNavs = $riContainer.find('.round-previous, .round-next');
	
	if ($riRoundNavs.length) {
		
		$riRoundNavs.each(function() {
			const $this = $(this);
			
			$this.on('click', function(e) {
				e.preventDefault();
				const $rounds = $riContainer.find('.regional-interactive-round-wrapper');
				const $activeRound = $rounds.filter('.active');
				const $nextRound = $this.hasClass('round-next') ? $activeRound.next() : $activeRound.prev();
				const targetRoundId = $nextRound.data('round-id');
				
				navigateToRound(targetRoundId, this);
			});
		});
	}
	
	// ROUNDS PAGINATION
	const $riRoundPagination = $riContainer.find('.round-pagination button');
	
	if ($riRoundPagination.length) {
		
		$riRoundPagination.each(function() {
			const $this = $(this);
			$this.on('click', function(e) {
				e.preventDefault();
				const targetRoundId = $this.data('round-id');
				navigateToRound(targetRoundId, this);
			});
		});
		
	}
		
	/***************************************************************
		Highlights drawer
	***************************************************************/

	const $riHighlightsDrawer = $riContainer.find('.round-highlights');
	
	if ($riHighlightsDrawer.length) {

		$riHighlightsDrawer.each(function() {
			const $this = $(this);
			const $toggle = $this.find('.highlights-drawer-toggle');
			const $drawer = $this.find('.highlights-drawer>div');
			
			$toggle.on('click', function(e) {
				e.preventDefault();
				$drawer.slideToggle(400, function() {
					
					if ($drawer.is(':visible')) {
						lenis.scrollTo($this.get(0), {
							offset: -140,
						});
						$toggle.text('View less');
					} else {
						lenis.scrollTo($toggle.get(0), {
							offset: -380,
						});
						$toggle.text('View more');
					}
				});
			});
		});
		
	}
	
	const $riMobileGamesDrawerToggle = $riContainer.find('.mobile-games-drawer-toggle');
	
	if ($riMobileGamesDrawerToggle.length) {
		
		$riMobileGamesDrawerToggle.each(function() {
			const $this = $(this);
			const totalHeight = $this.data('total-height');
			const $gamesWrap = $this.parent().find('.games-wrap');
			
			$this.on('click', function(e) {
				e.preventDefault();
				const initHeight = parseInt($gamesWrap.css('max-height').replace('px', ''));
				
				if (totalHeight > initHeight) {
					$gamesWrap.css('max-height', `${initHeight+328}px`);
					$this.find('span').text('Load More content');
				} else {
					$gamesWrap.css('max-height', '328px');
					lenis.scrollTo($gamesWrap.get(0), {
						offset: -328,
						onComplete: function() {
							$this.find('span').text('Load More content');
						}
					});
				}
				
				if (totalHeight < initHeight+328) {
					$this.find('span').text('View less matchups');
				}

			});
		});
		
	}
	
	/***************************************************************
		Game modals
	***************************************************************/

	const $riGameModals = $riContainer.find('.game-modals');
	const $riGameModalOpens = $riContainer.find('.game-pill');
	const $riGameModalCloses = $riContainer.find('.game-modal-close');
	
	if ($riGameModals.length) {
		
		// Function to handle Lenis state based on media query
		const updateModalLenisState = (e) => {
			if (e.matches) {
				// ≥61rem: re-enable Lenis if modal is open
				if ($riGameModals.hasClass('open')) {
					lenis.start();
				}
			} else {
				// <61rem: disable Lenis if modal is open
				if ($riGameModals.hasClass('open')) {
					lenis.stop();
				}
			}
		};

		// Add media query listener
		if (mq.addEventListener) {
			mq.addEventListener('change', updateModalLenisState);
		} else {
			mq.addListener(updateModalLenisState);
		}

		// Initial check
		updateModalLenisState(mq);
		
		$riGameModalOpens.each(function() {
			
			const $this = $(this);
			const $modal = $riGameModals.find(`.game-modal[data-game-id="${$this.data('game-id')}"]`);
			const $bg = $modal.parent();
			
			$this.on('click', function(e) {
				e.preventDefault();
				// Remove active class from all game pills
				$riGameModalOpens.add($riContainer).removeClass('active');
				// Close any open modals first
				$riGameModals.find('.game-modal.open').removeClass('open');
				$riGameModals.removeClass('open');
				
				// Then open the new modal and add active class to clicked pill
				$bg.add($modal).addClass('open');
				$this.add($riContainer).addClass('active');
				// Only stop Lenis on mobile
				if (!mq.matches) {
					lenis.stop();
				}
			});
			
		});
		
		$riGameModalCloses.each(function() {
			
			const $this = $(this);
			
			$this.on('click', function(e) {
				e.preventDefault();
				const $modal = $riContainer.find('.game-modal');
				const $bg = $riContainer.find('.game-modals');
				$bg.removeClass('open');
				$modal.removeClass('open');
				// Remove active class from all game pills
				$riGameModalOpens.add($riContainer).removeClass('active');
				// Only start Lenis on mobile
				if (!mq.matches) {
					lenis.start();
				}
				
			});
			
		});
	}
	
	/***************************************************************
		HEAT MAPS
	***************************************************************/
	
	const $riHeatMaps = $container.find('.round-map-chart > div');
	
	if ($riHeatMaps.length) {

		// Make sure RegionalApi.endpoint is now:
		RegionalApi.endpoint = '/wp-json/march-madness/v1/content';

		fetch(RegionalApi.endpoint, {
			headers: { 'X-WP-Nonce': RegionalApi.nonce }
		})
			.then(res => res.json())
			.then(dataset => {

				// 2) define your region→state membership
				const regionToStates = {
					"Midwest":   ["US-IL", "US-IN", "US-MI", "US-OH", "US-WI", "US-IA", "US-KS", "US-MN", "US-MO", "US-NE", "US-ND","US-SD"],
					"South":     ["US-DE", "US-DC", "US-FL", "US-GA", "US-MD", "US-NC", "US-SC", "US-VA", "US-WV", "US-AL", "US-KY", "US-MS", "US-TN", "US-AR", "US-LA", "US-OK", "US-TX"],
					"Northeast": ["US-CT", "US-ME", "US-MA", "US-NH", "US-RI", "US-VT", "US-NJ", "US-NY", "US-PA"],
					"West":      ["US-AZ", "US-CO", "US-ID", "US-MT", "US-NV", "US-NM", "US-UT", "US-WY", "US-AK", "US-CA", "US-HI", "US-OR", "US-WA"],
				};

				// 3) loop over each map container
				$riHeatMaps.each(function(idx) {
					const container = $(this).get(0);

					// pick the corresponding round object from your JSON
					// idx 0 → dataset[0], idx1 → dataset[1], etc.
					const roundData = dataset[idx];
					if (!roundData || !roundData.regionData) return;

					// build a quick lookup of region→viewers
					const viewersByRegion = {};
					roundData.regionData.forEach(r => {
						viewersByRegion[r.region] = r.viewers;
					});

					// prepare the AMCharts map
					const root = am5.Root.new(container);
					root.setThemes([ am5themes_Animated.new(root) ]);

					const chart = root.container.children.push(
						am5map.MapChart.new(root, {
							panX: "none",
							panY: "none",
							wheelX: "none",
							wheelY: "none",
							projection: am5map.geoAlbersUsa(),
							layout: root.verticalLayout
						})
					);

					const polygonSeries = chart.series.push(
						am5map.MapPolygonSeries.new(root, {
							geoJSON: am5geodata_usaLow,
							valueField: "value",
							calculateAggregates: true,
							//exclude: ["US-AK","US-HI"],
							stroke: am5.color(0x121212),
							strokeWidth: 4,
						})
					);

					// Add event handlers directly to mapPolygons
					polygonSeries.mapPolygons.template.events.on("pointerover", function(ev) {
						const dataItem = ev.target.dataItem;
						if (dataItem) {
							const value = dataItem.get("value");
							heatLegend.showValue(value);
						}
					});

					polygonSeries.mapPolygons.template.events.on("pointerout", function(ev) {
						heatLegend.hideTooltip();
					});

					polygonSeries.mapPolygons.template.setAll({
						tooltip: am5.Tooltip.new(root, {
							background: am5.RoundedRectangle.new(root, {
								fill: am5.color(0x121212),
								fillOpacity: 0,
								stroke: am5.color(0x414141),
								dx: 10,
								dy: 10,
								strokeOpacity: 0,
								marginTop: 0,
								marginBottom: 0,
								marginLeft: 0,
								marginRight: 0,
								minWidth: 180,
								minHeight: 96,
								maxWidth: 186,
								maxHeight: 100,
							})
						}),
						tooltipText: "[bold]Region: {region}[/] \nLive + SD AA (000): \n{value}",
						tooltipHTML: "<div class='tooltip-background' style='display: flex; flex-direction: column; gap: 10px; background-color: #121212; border: 1px solid #414141; border-radius: 8px; padding: 14px; width: 186px; height: 96px; z-index: 1; color: #ffffff; position: relative; top: 0; left: 0; font-size: 15px;'><strong>Region: {region}</strong><span>Live + SD AA (000):</span><span>{value}</span></div>"
					});

					polygonSeries.set("heatRules", [{
						target: polygonSeries.mapPolygons.template,
						dataField: "value",
						min: am5.color(0xC7C6F0),
						max: am5.color(0x4555A5),
						key: "fill"
					}]);

					// 4) build your data array by exploding each region → states
					const dataArray = [];
					Object.entries(regionToStates).forEach(([region, states]) => {
						const val = viewersByRegion[region] || 0;
						states.forEach(stateId => {
							// add region here
							dataArray.push({
								id: stateId,
								value: val,
								region: region
							});
						});
					});

					polygonSeries.data.setAll(dataArray);

					// 5) add legend
					const heatLegend = chart.children.push(
						am5.HeatLegend.new(root, {
							orientation: "horizontal",
							layout: root.horizontalLayout,
							x: am5.percent(50),
							centerX: am5.percent(50),
							y: am5.percent(100),
							centerY: am5.percent(100),
							startColor: am5.color(0xC7C6F0),
							endColor: am5.color(0x4555A5),
							startText: "Lowest",
							endText: "Highest",
							stepCount: 7,
							width: am5.percent(80)
						})
					);

					heatLegend.startLabel.setAll({ fontSize:12, fill: heatLegend.get("startColor") });
					heatLegend.endLabel.setAll({ fontSize:12, fill: heatLegend.get("endColor") });

					// Configure heat legend
					polygonSeries.events.on("datavalidated", () => {

						heatLegend.setAll({
							startValue: polygonSeries.getPrivate("valueLow"),
							endValue: polygonSeries.getPrivate("valueHigh")
						});
					});
				});

			})
			.catch(err => console.error("Could not load regional data:", err));

	}

	// Return cleanup function
	return () => {
		cleanupFunctions.forEach(cleanup => {
			if (typeof cleanup === 'function') {
				cleanup();
			}
		});
	};
};

export { 
	regionalInteractive 
};